module.exports = __webpack_public_path__ + "img/netflix-logo.34c020bb.png";